<template>
  <div class="spinner spinner--ping-pong">
    <div class="spinner-inner">
      <div class="board">
        <div class="left" :class="{ light }"></div>
        <div class="right" :class="{ light }"></div>
        <div class="ball" :class="{ light }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    light: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.spinner {
  width: 60px;
  height: 60px;

  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  * {
    line-height: 0;
    box-sizing: border-box;
  }

  .spinner-inner {
    transform: scale(0.24);

    .board {
      width: 250px;
      position: relative;

      .left,
      .right {
        height: 50px;
        width: 15px;
        background: $accent;
        display: inline-block;
        position: absolute;

        &.light {
          background: $accent-light;
        }
      }

      .left {
        left: 0;
        animation: pingpong-position1 2s linear infinite;
      }

      .right {
        right: 0;
        animation: pingpong-position2 2s linear infinite;
      }

      .ball {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: $accent;
        position: absolute;
        animation: pingpong-bounce 2s linear infinite;

        &.light {
          background: $accent-light;
        }
      }
    }
  }
}

@keyframes pingpong-position1 {
  0% {
    top: -60px;
  }
  25% {
    top: 0;
  }
  50% {
    top: 60px;
  }
  75% {
    top: -60px;
  }
  100% {
    top: -60px;
  }
}

@keyframes pingpong-position2 {
  0% {
    top: 60px;
  }
  25% {
    top: 0;
  }
  50% {
    top: -60px;
  }
  75% {
    top: -60px;
  }
  100% {
    top: 60px;
  }
}

@keyframes pingpong-bounce {
  0% {
    top: -35px;
    left: 10px;
  }
  25% {
    top: 25px;
    left: 225px;
  }
  50% {
    top: 75px;
    left: 10px;
  }
  75% {
    top: -35px;
    left: 225px;
  }
  100% {
    top: -35px;
    left: 10px;
  }
}
</style>
